import React from "react";
import { useSelector } from "react-redux";
import { getAllMaterialSpecifications } from "store/features/materialSpecs/specs";
import { Box } from "@material-ui/core";
import { InfoPanel } from "pages/MaterialSpecs/components";
import {
    MaterialDetailsContainer,
    MaterialOverviewContainer,
    MaterialPreviewContainer,
} from "pages/MaterialSpecs/MaterialSpecs.styled";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { AdMaterialAnnotationsProvider } from "pages/MaterialSpecs/components";
import { MaterialSpecsInfo } from "pages/MaterialSpecs/components/MaterialSpecsInfo/MaterialSpecsInfo";
import { AnnotationSection } from "pages/MaterialSpecs/components/AnnotationSection/AnnotationSection";

export const MaterialSpecsOverview = () => {
    const { isPreviewVisible } = useMaterialSpecs();
    const materialSpecifications = useSelector(getAllMaterialSpecifications);

    if (!materialSpecifications.length) {
        return null;
    }

    return (
        <AdMaterialAnnotationsProvider>
            <Box display="flex">
                <MaterialOverviewContainer display={!isPreviewVisible ? "block" : "none"}>
                    <MaterialSpecsInfo />
                </MaterialOverviewContainer>
                <MaterialPreviewContainer display={isPreviewVisible ? "block" : "none"}>
                    {isPreviewVisible && <AnnotationSection />}
                </MaterialPreviewContainer>
                <MaterialDetailsContainer>
                    <InfoPanel />
                </MaterialDetailsContainer>
            </Box>
        </AdMaterialAnnotationsProvider>
    );
};
